import { Serializable } from '@/models/core/serializable';

export class StudentFindingsProposals implements Serializable<StudentFindingsProposals> {
  highCompetencies: FindingsProposalDescription[] = []; // 特に高いコンピテンシー
  mostGrownCompetencies: FindingsProposalDescription[] = []; // 特に成長したコンピテンシー

  deserialize(input: any): StudentFindingsProposals {
    if (input.highCompetencies) {
      this.highCompetencies = input.highCompetencies.map((highCompetency: FindingsProposalDescription) => new FindingsProposalDescription().deserialize(highCompetency));
    }
    if (input.mostGrownCompetencies) {
      this.mostGrownCompetencies = input.mostGrownCompetencies.map((mostGrownCompetency: FindingsProposalDescription) => new FindingsProposalDescription().deserialize(mostGrownCompetency));
    }
    return this;
  }
}

export class FindingsProposalDescription implements Serializable<FindingsProposalDescription> {
  competencyID: number;
  competencyName: string;
  competencyScore: number;
  description1: string;
  description2: string;
  description3: string;
  isInitiative: boolean;
  isCollaboration: boolean;

  deserialize(input: any): FindingsProposalDescription {
    this.competencyID = input.competencyID;
    this.competencyName = input.competencyName;
    this.competencyScore = input.competencyScore;
    this.description1 = input.description1;
    this.description2 = input.description2;
    this.description3 = input.description3;
    this.isInitiative = input.isInitiative;
    this.isCollaboration = input.isCollaboration;
    return this;
  }
}
